module.exports = __webpack_public_path__ + "static/media/22.7c64fa6b.jpg";